// Configuration identity, not an API key or tenant selector (TCA-26101307).
export function dispatchMapId(value = process.env.REACT_APP_GOOGLE_MAPS_DISPATCH_MAP_ID) {
  const id = typeof value === 'string' ? value.trim() : '';
  if (!id || id.toUpperCase() === 'DEMO_MAP_ID') {
    throw new Error('Dispatch map configuration is missing. Your orders and run drafts are unchanged.');
  }
  return id;
}

// Map-specific capability can arrive after construction. Bounded event-based
// observation, never polling and never a second bootstrap. Cleanup owns both.
export function observeDispatchMarkers(map, onReady, onUnavailable) {
  let active = true;
  let timer;
  let listener;
  const stop = () => {
    active = false;
    clearTimeout(timer);
    if (listener) window.google.maps.event.removeListener(listener);
    listener = null;
  };
  const fail = () => {
    if (!active) return;
    stop();
    onUnavailable(new Error('Dispatch map markers are unavailable. Check the configured map ID before release. Your orders and run drafts are unchanged.'));
  };
  const check = () => {
    if (!active) return;
    let ready;
    try {
      ready = map.getMapCapabilities?.()?.isAdvancedMarkersAvailable;
    } catch {
      fail();
      return;
    }
    if (!ready) return;
    stop();
    onReady();
  };
  timer = setTimeout(fail, 10000);
  try {
    listener = map.addListener('mapcapabilities_changed', check);
    check();
  } catch {
    fail();
  }
  return stop;
}
